/* Happy Yay Holiday landing (hy-holiday): phase switch, countdown, tabs, daily rotation, snow, reveal, sticky bar */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pad = function (n) { return String(n).padStart(2, '0'); };

  function parseDate(str) {
    // "YYYY-MM-DDT23:59:59" in shopper's local time
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/.exec(str || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]).getTime() : NaN;
  }

  // Same picks all day, new picks every day (shopper's local date). Works with cached pages.
  function rotate(root) {
    var day = Math.floor((Date.now() - new Date().getTimezoneOffset() * 60000) / 86400000);
    root.querySelectorAll('[data-hy-rotate]').forEach(function (grid) {
      if (grid.hasAttribute('data-hy-done')) return;
      grid.setAttribute('data-hy-done', '');
      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-hy-item]'));
      var fixed = grid.querySelector(':scope > [data-hy-fixed]');
      var n = parseInt(grid.getAttribute('data-show'), 10) || 4;
      var salt = 0, s = grid.getAttribute('data-salt') || '';
      for (var k = 0; k < s.length; k++) salt = (salt * 31 + s.charCodeAt(k)) % 100000;
      var seed = (day * 9301 + salt * 49297) % 233280;
      var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
      for (var i = items.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var t = items[i]; items[i] = items[j]; items[j] = t; }
      items.forEach(function (el, idx) { if (idx < n) grid.appendChild(el); else el.remove(); });
      if (fixed) grid.appendChild(fixed);
    });
  }

  function tabs(root) {
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;
    var btns = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(i, focus) {
      btns.forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) btns[i].focus();
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
    list.addEventListener('keydown', function (e) {
      var i = btns.indexOf(document.activeElement); if (i < 0) return;
      var k = e.key, n = btns.length;
      if (k === 'ArrowRight') i = (i + 1) % n; else if (k === 'ArrowLeft') i = (i - 1 + n) % n;
      else if (k === 'Home') i = 0; else if (k === 'End') i = n - 1; else return;
      e.preventDefault(); select(i, true);
    });
  }

  function snow(root) {
    var box = root.querySelector('[data-snow]');
    if (!box || reduce) return;
    var x = 5421, rnd = function () { x = (x * 9301 + 49297) % 233280; return x / 233280; };
    for (var i = 0; i < 28; i++) {
      var f = document.createElement('span'), sz = (rnd() * 3 + 2).toFixed(1) + 'px';
      f.className = 'hy-snow';
      f.style.cssText = 'left:' + (rnd() * 98).toFixed(1) + '%;width:' + sz + ';height:' + sz + ';animation-duration:' + (rnd() * 4 + 5).toFixed(1) + 's;animation-delay:' + (rnd() * 6).toFixed(1) + 's;opacity:' + (rnd() * .5 + .4).toFixed(2);
      box.appendChild(f);
    }
  }

  function reveal(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('.hy-reveal'));
    var check = function () {
      var h = window.innerHeight;
      els.forEach(function (el) { if (el.classList.contains('is-in')) return; var r = el.getBoundingClientRect(); if (r.top < h * 0.9 && r.bottom > 0) el.classList.add('is-in'); });
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  function init(root) {
    if (root.hasAttribute('data-hy-init')) return;
    root.setAttribute('data-hy-init', '');
    var cutoff = parseDate(root.getAttribute('data-cutoff'));
    var yearEnd = parseDate(root.getAttribute('data-yearend'));
    var phase = Date.now() <= cutoff ? 'christmas' : 'newyear';
    var target = phase === 'christmas' ? cutoff : yearEnd;
    root.querySelectorAll('[data-phase]').forEach(function (el) { el.hidden = el.getAttribute('data-phase') !== phase; });

    var cd = {}; ['d', 'h', 'm', 's'].forEach(function (k) { cd[k] = root.querySelector('[data-cd="' + k + '"]'); });
    var stickyTime = root.querySelector('[data-sticky-time]');
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 864e5); diff -= d * 864e5;
      var h = Math.floor(diff / 36e5); diff -= h * 36e5;
      var m = Math.floor(diff / 6e4); diff -= m * 6e4;
      var s = Math.floor(diff / 1e3);
      if (cd.d) { cd.d.textContent = d; cd.h.textContent = pad(h); cd.m.textContent = pad(m); cd.s.textContent = pad(s); }
      if (stickyTime) stickyTime.textContent = d > 0 ? d + 'd ' + pad(h) + 'h' : pad(h) + 'h ' + pad(m) + 'm';
    }
    tick(); setInterval(tick, 1000);

    rotate(root); tabs(root); snow(root); reveal(root);

    var sticky = root.querySelector('.hy-sticky');
    if (sticky) {
      var dismissed = false;
      sticky.hidden = false;
      var onScroll = function () { if (!dismissed) sticky.classList.toggle('is-on', window.scrollY > 600); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      var x = sticky.querySelector('[data-sticky-close]');
      if (x) x.addEventListener('click', function () { dismissed = true; sticky.classList.remove('is-on'); });
    }
  }

  function boot() { document.querySelectorAll('.hy-hol').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.hy-hol'); if (r) init(r); });
})();
